import './styles.sass';

import React, { useState } from 'react';
import Transition from 'components/Explorer/Transition';
import { isEmpty } from 'lodash-es';
import { Link } from 'react-router-dom';

import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';
import { ContinentsWorldMap, CountriesWorldMap } from './WorldMap';

const DETAIL_LEVEL = { continents: 'continents', countries: 'countries' };

const Demographics = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/demographics', params, { reloadOn: ['filters'] });
  const [detailLevel, setDetailLevel] = useState(DETAIL_LEVEL.continents);

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = data && !isEmpty(data);

  const handleSetDetailLevel = (level) => {
    Analytics.trackEvent('highlights-demographics-set-view', { detailLevel: level });
    setDetailLevel(level);
  };

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    if (!hasResults) {
      return <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.Demographics.empty')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-Demographics-content">
        <div>
          <div className="detail-level-selector">
            <button
              className={detailLevel === DETAIL_LEVEL.continents ? 'active' : 'not-active'}
              onClick={() => handleSetDetailLevel(DETAIL_LEVEL.continents)}
            >
              {I18n.t('Explorer.Highlights.Demographics.toggle.continents')}
            </button>
            <button
              className={detailLevel === DETAIL_LEVEL.countries ? 'active' : 'not-active'}
              onClick={() => handleSetDetailLevel(DETAIL_LEVEL.countries)}
            >
              {I18n.t('Explorer.Highlights.Demographics.toggle.countries')}
            </button>
          </div>
          {detailLevel === DETAIL_LEVEL.continents ? (
            <ContinentsWorldMap data={data} />
          ) : (
            <CountriesWorldMap data={data} />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="Highlights-Demographics Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.Demographics.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>
          {isLoading ? <div key="loadingMessage" className="Highlights-loading-message" /> : content()}
        </Transition>
        {hasResults && (
          <Link
            onClick={() => Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'demographics' })}
            to={QueryParams.locationFor(params, '/demographics')}
            className="Highlights-jump-link"
          >
            {I18n.t('Explorer.Highlights.Demographics.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default Demographics;
